export default "__VITE_ASSET__kodaA4lD__"